import { CorpusId } from '../models/aliases';
import { Paper } from '../models/result-set';
import { PaperCard } from './paper/PaperCard';
import { PaperComponent } from './paper/PaperComponent';
import { PaperReaction, Reaction } from '../models/reactions';
import { PaperTitleOverrideProps } from './PapersPanel';
import { Scroller } from '../styled/mui';

import { createRef, useEffect } from 'react';
import styled from 'styled-components';

interface PapersResultProps {
  papersData: Array<Paper>;
  selectedPapers: Array<CorpusId>;
  onPaperSelectionChange: (corpusId: CorpusId, isSelect: boolean) => void;
  AdditionalControlsComponent?: PaperComponent;
  PaperTitleOverride?: React.FC<PaperTitleOverrideProps>;
  isReadOnly: boolean;
  reactions: Array<PaperReaction>;
  onReactionChanged?: (
    corpusId: CorpusId,
    reaction: Reaction | undefined,
  ) => void;
  onTextFeedbackSubmitted?: (corpusId: CorpusId, text: string) => void;
}

export function PapersResult(props: PapersResultProps): JSX.Element {
  const {
    papersData,
    selectedPapers,
    onPaperSelectionChange,
    AdditionalControlsComponent,
    PaperTitleOverride,
    isReadOnly,
    reactions,
    onReactionChanged = () => {},
    onTextFeedbackSubmitted = () => {},
  } = props;
  const divRef = createRef<HTMLDivElement>();

  // Whenever the order of the items changes, scroll to top
  useEffect(() => {
    divRef.current?.scrollTo(0, 0);
  }, [papersData[0]?.corpusId]);

  return (
    <>
      {papersData && papersData.length > 0 && (
        <MainLayout ref={divRef}>
          {papersData.map((paper) => {
            return (
              <PaperCard
                isReadOnly={isReadOnly}
                paper={paper}
                key={paper.corpusId}
                selected={selectedPapers.includes(paper.corpusId)}
                onPaperSelectionChange={onPaperSelectionChange}
                AdditionalControlsComponent={AdditionalControlsComponent}
                titleOverride={
                  PaperTitleOverride ? (
                    <PaperTitleOverride
                      corpusId={paper.corpusId}
                      title={paper.title}
                    />
                  ) : undefined
                }
                reactionEntry={reactions.find(
                  (r) => r.corpusId === paper.corpusId,
                )}
                onReactionChanged={onReactionChanged}
                onTextFeedbackSubmitted={onTextFeedbackSubmitted}
              />
            );
          })}
        </MainLayout>
      )}
    </>
  );
}

const MainLayout = styled(Scroller)`
  padding: 15px;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-x: hidden;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 12px;
  }
`;
